<template>
    <div class="modal-content">

        <div class="modal-header">
            <h5 class="modal-title" >Pagamento</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body  p-0">
            <div class="card mx-0">
                <div class="card-header">
                    <h4 class="card-title">Como vai ser a forma de pagamento?</h4>
                </div>

                <div v-if="carregando" class="card-body text-center">
                    <div class="spinner-border text-info my-5" role="status">
                        <span class="sr-only">Carregando...</span>
                    </div>
                    <p>...</p>
                </div>

                <div v-else class="card-body">

                    <!-- ESCOLHER FORMA DE PAGAMENTO -->
                    <div class="row">
                        <div v-for="pagamento in formasPagamento.filter(pagamento => pagamento.disponivel)" :key="pagamento.id" class="col-4">
                            <div v-if="pagamento.id==1" class="info-box" @click="form.pagamento_id=1" >
                                <span  class="info-box-icon bg-success elevation-1">
                                    <i class="fas fa-money-bill"></i>
                                </span>
                                <div class="info-box-content">
                                    <span class="info-box-text">{{pagamento.nome}}</span>
                                </div>
                                <span  v-if="form.pagamento_id==1" class="check"><i class="fas fa-check-circle"></i></span>
                            </div>

                            <div v-if="pagamento.id==2" class="info-box" @click="form.pagamento_id=2" >
                                <span  class="info-box-icon bg-warning elevation-1">
                                    <i class="fas fa-credit-card"></i>
                                </span>
                                <div class="info-box-content">
                                    <span class="info-box-text">{{pagamento.nome}}</span>
                                </div>
                                <span  v-if="form.pagamento_id==2" class="check"><i class="fas fa-check-circle"></i></span>
                            </div>

                            <div v-if="pagamento.id==3" class="info-box" @click="form.pagamento_id=3" >
                                <span  class="info-box-icon bg-info elevation-1">
                                    <i class="fas fa-mobile-alt"></i>
                                </span>
                                <div class="info-box-content">
                                    <span class="info-box-text">{{pagamento.nome}}</span>
                                </div>
                                <span  v-if="form.pagamento_id==3" class="check"><i class="fas fa-check-circle"></i></span>
                            </div>
                        </div>
                    </div>

                    <!-- ESCOLHER BANDEIRAS -->
                    <div class="row" v-if="form.pagamento_id==2">
                        <div v-for="bandeira in bandeiras" :key="bandeira.id" class="col-3 px-1">
                            <div class="info-box"  @click="selecionarBandeira(bandeira)" >
                                <span  class="info-box-img elevation-1">
                                    <img :src="bandeira.imagem_url ||'/media/images/card.png'" width="70" height="40" :alt="bandeira.nome" class="img-bord">
                                </span>
                                <div class="info-box-content">
                                    <span class="info-box-text info-bandeira-text">{{bandeira.nome}}</span>
                                </div>
                                <span  v-if="form.bandeira_id==bandeira.id" class="check-card"><i class="fas fa-check-circle"></i></span>
                            </div>
                        </div>

                    </div>

                    <!-- TROCO -->
                    <div v-if="form.pagamento_id == 1">
                        <label class="control-label" for="troco">Troco para:</label>
                        <money
                            v-model="form.troco"
                            type="text"
                            id="troco" name="troco"
                            class="form-control form-control-lg"
                            :class="{ 'is-invalid': form.errors.has('troco') }"
                            :disabled="form.pagamento_id != 1"
                        >
                        </money>
                    </div>

                    <!-- CHAVE PIX -->
                    <div class="row" v-if="form.pagamento_id==3">
                        <div class="col">
                            <h4>Chave Pix:</h4>
                            <p>
                                <span class="pix">
                                    <input type="text" ref="copiar" :value="formasPagamento.find(pagamento =>pagamento.id==3).chave" readonly>
                                    <i @click="copiarTexto()" class="far fa-clone"></i>
                                </span>
                            </p>


                            <h6>Tipo: {{formasPagamento.find(pagamento =>pagamento.id==3).tipo_de_chave}}</h6>
                            <h6>Titular: {{formasPagamento.find(pagamento =>pagamento.id==3).nome_do_titular}} </h6>
                            <div v-if="formasPagamento.find(pagamento =>pagamento.id==3).obs != null" class="alert alert-danger text-center" role="alert">
                                <strong>{{formasPagamento.find(pagamento =>pagamento.id==3).obs}} </strong>
                            </div>
                        </div>

                    </div>

                    <!-- CUPONS DE DESCONTO -->
                    <div class="row">
                        <div class="col card mt-3">
                            <div class="card-body">
                                <div class="row mb-2">
                                    <div class="col text-center">
                                        <h3>Tem algum cupon de desconto?</h3>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <input v-model="form.codigo_desconto" type="text" class="form-control  mr-2 rounded" placeholder="CUPOM DE DESCONTO">
                                    </div>
                                    <div class="col-auto">
                                        <button type="button" class="btn b-btn" @click="validarCupom()" >INSERIR CUPOM</button>
                                    </div>
                                </div>
                                <div v-if="!carregandoCupom" class="row">
                                    <div class="col">
                                        <div v-if="cupom_mensage!=''">

                                            <div v-if="!cupom_erro" class="alert alert-success my-3" role="alert">
                                                {{cupom_mensage}}
                                            </div>

                                            <div v-else class="alert alert-danger my-3" role="alert">
                                                {{cupom_mensage}}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div v-else class="text-center">
                                    <div class="spinner-border text-info my-5" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>


                    <div class="row">
                        <div class="col card mt-4">
                            <div class="card-body">

                                <table class="table">

                                    <tr v-if="valorItens!=null">
                                        <th>Valor dos itens:</th>
                                        <td class="text-right">R$ {{ formatarMoeda(valorItens) }}</td>
                                    </tr>

                                    <tr v-if="dados_entrega.frete!=0">
                                        <th>Frete</th>
                                        <td class="text-right">R$ {{ formatarMoeda(dados_entrega.frete) }}</td>
                                    </tr>

                                    <tr v-if="form.desconto!=0">
                                        <th>Desconto</th>
                                        <td class="text-right">- R$ {{ formatarMoeda(form.desconto) }}</td>
                                    </tr>

                                    <tr>
                                        <th><h3>Valor Total:</h3></th>
                                        <td class="text-right"><h3>R$ {{ formatarMoeda(valorTotal) }}</h3></td>
                                    </tr>
                                </table>

                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </div>

        <div class="modal-footer">
            <button type="button" class="btn btn-secondary mr-auto" data-dismiss="modal">Fechar</button>
            <button type="submit" class="btn b-btn"  v-on:click="dispararEvento('endereco')">voltar</button>
            <button type="submit" class="btn b-btn"  v-on:click="validarCampos()">Proseguir</button>
        </div>

    </div>
</template>

<script>
import api from "../../service/api";
export default {

    props: ['inquilino', 'valorItens', 'dados_entrega'],

    data () {
        return {
            carregando:false,

            bandeiras:[],
            formasPagamento:[],

            form: new Form({
                pagamento_id: null,
                troco: null,
                bandeira_id: null,
                bandeira_nome: null,
                cupom_id: null,
                codigo_desconto:null,
                desconto:0,
            }),

            //CUPONS DE DESCONTO
            carregandoCupom:false,
            cupom:{},
            cupom_mensage:'',
            codigo_desconto:'',
            cupom_erro:false,

        }
    },

    watch: {

        'dados_entrega.entrega_id': function (n) {

            if (this.form.codigo_desconto) {
                this.validarCupom();
            }
        },

    },

    computed: {
        valorTotal(){

            return this.valorItens+this.dados_entrega.frete-this.form.desconto;
        }
    },

    methods: {

        dispararEvento(pagina){

            var obj = {
                pagina: pagina,
                pagamento: {
                    pagamento_id: this.form.pagamento_id,
                    troco: this.form.troco,
                    bandeira_id: this.form.bandeira_id,
                    bandeira_nome: this.form.bandeira_nome,
                    cupom_id: this.form.cupom_id,
                    desconto: this.form.desconto,
                }
            };

            this.$emit('componente-ativo', obj);
        },

        async loadBandeiras(){
            this.carregando = true;
            await api
            .get('/bandeiras')
            .then(response => (this.bandeiras = response.data));

            this.carregando = false
        },

        async carregarFormasPagamento(){
            this.carregando = true;
            await api
            .get('/formas-pagamentos')
            .then(response => (this.formasPagamento = response.data));

            this.carregando = false
        },

        formatarMoeda(valor){
            return parseFloat(valor).toFixed(2).replace(".",",")
        },

        async validarCupom(){
            this.carregandoCupom = true;

            let formData = new FormData();

            formData.append('codigo', this.form.codigo_desconto);
            formData.append('usuario_id', this.form.usuario_id);
            formData.append('valor', this.valorTotal);

            await api.post('/cupons/validar' ,formData)
            .then((response) => {

                if (response.data.success) {

                    if ((response.data.cupom.entrega_balcao==1 && this.dados_entrega.entrega_id == 1)||(response.data.cupom.entrega_delivery==1 && this.dados_entrega.entrega_id == 2)) {
                        this.cupom = response.data.cupom;
                        this.form.cupom_id = response.data.cupom.id;
                        this.form.desconto = response.data.valor_desconto;
                        this.cupom_mensage = 'Cupom Válido';
                        this.cupom_erro = false;
                    }else{
                        this.form.desconto = 0;
                        this.cupom = {};
                        this.form.cupom_id = null;
                        this.cupom_mensage = 'Cupom não é valido para a forma de entrega selecionada';
                        this.cupom_erro = true;
                    }

                }else{
                    this.form.desconto = 0;
                    this.cupom_mensage = response.data.message
                    this.cupom_erro = true
                }
                this.carregandoCupom = false;

            })
            .catch(() => {
                this.$Progress.fail();
                this.carregandoModal = false;
                Toast.fire({
                        icon: 'error',
                        title: 'Algo deu errado!'
                    });
                this.cupom_erro = true
                this.carregandoCupom = false;
            });

        },

        validarCampos(){
            this.isLoading = true

            setTimeout(() => {
                this.isLoading = false
            }, 1000)

            if (this.valorTotal<this.inquilino.valor_minimo) {
                Swal.fire({
                        title: 'Valor minimo não alcançado',
                        text: "O valor minimo para esse pedido é de: R$ "+this.formatarMoeda(this.inquilino.valor_minimo),
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Ok!'
                    })
            } else if (this.form.pagamento_id==null) {

                Swal.fire({
                        title: 'Escolha uma forma de Pagamento',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Ok!'
                    })

            }else if (this.form.pagamento_id==2) {

                if (this.form.bandeira_id==null) {

                    Swal.fire({
                        title: 'Você deve escolher uma bandeira para essa forma de Pagamento',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Ok!'
                    })

                }else{
                    this.dispararEvento('confirmar-dados');
                }

            }else {
                this.dispararEvento('confirmar-dados');
            }
        },

        selecionarBandeira($bandeira){
            this.form.bandeira_id = $bandeira.id;
            this.form.bandeira_nome = $bandeira.nome;
        },

        async init(){
            await this.loadBandeiras();
            await this.carregarFormasPagamento();
        },

    },

    async mounted() {

        await this.init();
    }

}
</script>

<style  scoped>

.img-bord{
    border: 1px solid rgb(167, 167, 167);
    border-radius: 5px;
    object-fit: cover;
}

.info-box {
    box-shadow: 0 0 1px rgb(0 0 0 / 13%), 0 1px 3px rgb(0 0 0 / 20%);
    border-radius: 0.25rem;
    background-color: #fff;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    min-height: 100px;
    padding: 0.5rem;
    position: relative;
    cursor: pointer;
}
.info-box:hover{
    box-shadow: 0px 0px 6px 1px #b9b9b9;
}

.info-box .info-box-icon {
    border-radius: 0.25rem;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    font-size: 2.5rem;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    text-align: center;
    height: 80px;
}

.info-box .info-box-img {
    border-radius: 0.25rem;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    font-size: 2.5rem;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    text-align: center;
}

.info-box .info-box-content {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    line-height: 1.8;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    padding: 0 10px;
    align-items: center;
    text-align: center;
}

.info-bandeira-text{
    font-size: 0.75rem;
}

.check{
    position: absolute;
    top: 10px;
    left: 15px;
    font-size: 28px;
    color: #fff;
}

.check-card{
    position: absolute;
    top: -4px;
    left: 60px;
    font-size: 28px;
    color: #fff;
}

.check i, .check-card i {
    filter: drop-shadow(0 0 6px #666666);
}

.pix input{
    display: block;
    padding: 10px;
    border: 1px solid #9b9b9b;
    border-radius: 8px;
    background-color: #fff;
    width: 100%;
}

.pix i{
    cursor: pointer;
    position: absolute;
    top: 45px;
    right: 30px;
}


</style>
